import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { ThemeProvider } from '@emotion/react';
import { Container, Row, Col } from '../src';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "api"
    }}>{`API`}</h1>
    <h2 {...{
      "id": "default-values"
    }}>{`Default values`}</h2>
    <p>{`With exception the `}<a parentName="p" {...{
        "href": "/utilities"
      }}>{`media query`}</a>{` that use `}<strong parentName="p">{`rem`}</strong>{` unit.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}>{`type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Extra small (xs)`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Small (sm)`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Medium (md)`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Larger (lg)`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Extra large (xl)`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Container`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`shape`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`'full'`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`'full'`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`45`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`60`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`71.25`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Padding`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.875`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.875`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.875`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.875`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.875`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Columns`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`4`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`8`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`12`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`12`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`12`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Gutter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.875`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.875`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.875`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.875`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1.875`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Breakpoints`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`33.75`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`48`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`64`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`71.25`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "debug"
    }}>{`debug`}</h3>
    <blockquote>
      <p parentName="blockquote">{`You can use only rgb color`}</p>
    </blockquote>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}>{`type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`debug`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`'#0470F5'`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Color of grid on debug mode`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "custom-config"
    }}>{`Custom config`}</h2>
    <p>{`To set your custom config, you need to import the ThemeProvider from emotion theming', and pass a named object `}<inlineCode parentName="p">{`grid`}</inlineCode>{` to the theme prop, as the example below:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { ThemeProvider } from '@emotion/react';
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`Try to change the config in playground:`}</p>
    </blockquote>
    <Playground __position={0} __code={'() => {\n  const theme = {\n    grid: {\n      container: {\n        xs: \'full\',\n        sm: \'full\',\n        md: 45,\n        lg: 60,\n        xl: 71.25,\n      },\n      padding: {\n        xs: 1.875,\n        sm: 1.875,\n        md: 1.875,\n        lg: 1.875,\n        xl: 1.875,\n      },\n      columns: {\n        xs: 4,\n        sm: 8,\n        md: 12,\n        lg: 12,\n        xl: 12,\n      },\n      gutter: {\n        xs: 1.875,\n        sm: 1.875,\n        md: 1.875,\n        lg: 1.875,\n        xl: 1.875,\n      },\n      breakpoints: {\n        xs: 1,\n        sm: 33.75,\n        md: 48,\n        lg: 64,\n        xl: 71.25,\n      },\n      colors: {\n        blue: \'#0470F5\',\n      },\n    },\n  }\n  return (\n    <ThemeProvider theme={theme}>\n      <Container debug>\n        <Row>\n          <Col>Col auto</Col>\n        </Row>\n        <Row>\n          <Col md={4} lg={6}>\n            Col-md-4 Col-lg-6\n          </Col>\n          <Col md={4} lg={6}>\n            Col-md-4 Col-lg-6\n          </Col>\n        </Row>\n        <Row>\n          <Col md={2} lg={3}>\n            Col-md-2 Col-lg-3\n          </Col>\n          <Col md={2} lg={3}>\n            Col-md-2 Col-lg-3\n          </Col>\n          <Col md={2} lg={3}>\n            Col-md-2 Col-lg-3\n          </Col>\n          <Col md={2} lg={3}>\n            Col-md-2 Col-lg-3\n          </Col>\n        </Row>\n      </Container>\n    </ThemeProvider>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      ThemeProvider,
      Container,
      Row,
      Col,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {() => {
        const theme = {
          grid: {
            container: {
              xs: 'full',
              sm: 'full',
              md: 45,
              lg: 60,
              xl: 71.25
            },
            padding: {
              xs: 1.875,
              sm: 1.875,
              md: 1.875,
              lg: 1.875,
              xl: 1.875
            },
            columns: {
              xs: 4,
              sm: 8,
              md: 12,
              lg: 12,
              xl: 12
            },
            gutter: {
              xs: 1.875,
              sm: 1.875,
              md: 1.875,
              lg: 1.875,
              xl: 1.875
            },
            breakpoints: {
              xs: 1,
              sm: 33.75,
              md: 48,
              lg: 64,
              xl: 71.25
            },
            colors: {
              blue: '#0470F5'
            }
          }
        };
        return <ThemeProvider theme={theme} mdxType="ThemeProvider">
        <Container debug mdxType="Container">
          <Row mdxType="Row">
            <Col mdxType="Col">Col auto</Col>
          </Row>
          <Row mdxType="Row">
            <Col md={4} lg={6} mdxType="Col">
              Col-md-4 Col-lg-6
            </Col>
            <Col md={4} lg={6} mdxType="Col">
              Col-md-4 Col-lg-6
            </Col>
          </Row>
          <Row mdxType="Row">
            <Col md={2} lg={3} mdxType="Col">
              Col-md-2 Col-lg-3
            </Col>
            <Col md={2} lg={3} mdxType="Col">
              Col-md-2 Col-lg-3
            </Col>
            <Col md={2} lg={3} mdxType="Col">
              Col-md-2 Col-lg-3
            </Col>
            <Col md={2} lg={3} mdxType="Col">
              Col-md-2 Col-lg-3
            </Col>
          </Row>
        </Container>
      </ThemeProvider>;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      